
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const AddProduct = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_ADD_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'PRODUCT_ADD_ERROR':
            return { loading: false, error: true, data: [] };
        case 'PRODUCT_ADD_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'PRODUCT_ADD_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default AddProduct